<template>
  <div class="sidebar-area">
    <div class="logo position-relative">
      <RouterLink to="/users" class="d-block text-decoration-none position-relative">
        <img src="/favicon-32x32.png" alt="logo-icon" />
        <span class="logo-text fw-bold text-dark"> EEdT</span>
      </RouterLink>
      <button
        class="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
        id="sidebar-burger-menu" @click="stateStoreInstance.onChange">
        <i data-feather="x"></i>
      </button>
    </div>

    <div class="layout-menu menu-vertical menu hover-scroll-bar">
      <ul class="menu-inner">
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">Mantenimientos</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/tournaments" class="menu-link">
            <span class="material-symbols-outlined menu-icon">trophy</span>
            <span class="title">Torneos</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/matches" class="menu-link">
            <span class="material-symbols-outlined menu-icon">scoreboard</span>
            <span class="title">Partidos</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/plays" class="menu-link">
            <span class="material-symbols-outlined menu-icon">sports_and_outdoors</span>
            <span class="title">Jugadas</span>
          </RouterLink>
        </li>
        <li class="menu-item has-submenu" :class="{ open: isOpen('archivo') }">
          <a href="javascript:void(0)" class="menu-link" @click="toggleMenu('archivo')">
            <span class="material-symbols-outlined menu-icon">strategy</span>
            <span class="title">Archivo</span>
            <span class="material-symbols-outlined arrow">keyboard_arrow_down</span>
          </a>
          <ul class="submenu" v-show="isOpen('archivo')">
            <li class="menu-item">
              <RouterLink to="/repository" class="menu-link">
                Jugadas
              </RouterLink>
            </li>
      <!--       <li class="menu-item">
              <RouterLink to="/questions" class="menu-link">
                Preguntas
              </RouterLink>
            </li> -->
          </ul>
        </li>
        <li class="menu-item">
          <RouterLink to="/companies" class="menu-link">
            <span class="material-symbols-outlined menu-icon">business</span>
            <span class="title">Empresas/Instituciones</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/promotors" class="menu-link">
            <span class="material-symbols-outlined menu-icon">card_membership</span>
            <span class="title">Promotores</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/players" class="menu-link">
            <span class="material-symbols-outlined menu-icon">sports_kabaddi</span>
            <span class="title">Jugadores</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/teams" class="menu-link">
            <span class="material-symbols-outlined menu-icon">diversity_3</span>
            <span class="title">Equipos</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/prizes" class="menu-link">
            <span class="material-symbols-outlined">rewarded_ads</span>
            <span class="title">Trofeos</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/player-complaints" class="menu-link">
            <span class="material-symbols-outlined menu-icon">brightness_alert</span>
            <span class="title">Denuncias de jugadas</span>
            <span v-if="userLogin && userLogin.countPlayerComplaint > 0" class="dot">{{
              userLogin.countPlayerComplaint > 99
                ? "+99"
                : userLogin.countPlayerComplaint
            }}</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/notifications" class="menu-link">
            <span class="material-symbols-outlined">notifications</span>
            <span class="title">Notificaciones</span>
          </RouterLink>
        </li>        
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">Configuración</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/users" class="menu-link">
            <span class="material-symbols-outlined menu-icon">group_add</span>
            <span class="title">Usuarios</span>
          </RouterLink>
        </li>

        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">Consultas</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/queries/plays-content" class="menu-link">
            <span class="material-symbols-outlined menu-icon">sports_and_outdoors</span>
            <span class="title">Jugadas</span>
          </RouterLink>
        </li>

        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">Reportes</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/reports/tournament-teams-and-players" class="menu-link">
            <span class="material-symbols-outlined menu-icon">analytics</span>
            <span class="title">Equipos y torneos</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/reports/tournament-statistics" class="menu-link">
            <span class="material-symbols-outlined menu-icon">analytics</span>
            <span class="title">Estadísticas del Torneo</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/reports/tournament-player-data" class="menu-link">
            <span class="material-symbols-outlined menu-icon">database</span>
            <span class="title">Data Torneo</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/reports/tournament-players-prizes" class="menu-link">
            <span class="material-symbols-outlined menu-icon">trophy</span>
            <span class="title">Premios</span>
          </RouterLink>
        </li>
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">Otros</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/login" class="menu-link">
            <span class="material-symbols-outlined menu-icon">logout</span>
            <span class="title">Cerrar sesión</span>
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import feather from "feather-icons";
import stateStore from "../../utils/store";

export default defineComponent({
  name: "LeftSidebar",
  setup() {
    const userLogin = ref({});
    const stateStoreInstance = stateStore;

    // Reactive state to track which menu items are open
    const openMenu = ref(null);

    // Method to toggle the menu items
    const toggleMenu = (menu) => {
      // If the same menu is clicked, toggle it; otherwise, open the clicked menu
      openMenu.value = openMenu.value === menu ? null : menu;
    };

    // Method to check if a menu is open
    const isOpen = (menu) => {
      return openMenu.value === menu;
    };

    onMounted(() => {
      feather.replace();
      userLogin.value = JSON.parse(localStorage.getItem("user"));
      window.addEventListener("user-updated", () => {
        userLogin.value = JSON.parse(localStorage.getItem("user"));
      });
    });


    return {
      stateStoreInstance,
      toggleMenu,
      isOpen,
      userLogin,
    };
  },
});
</script>